import React, { useState, useEffect } from "react";
import {
  Box,
  Image,
  Text,
  Heading,
  Badge,
  IconButton,
  HStack,
  VStack,
  Button,
  Spacer,
} from "@chakra-ui/react";
import Translate from "../../../components/LanguageTranslation/Translate";
import { useCurrency } from "../../CurrencyExchange/CurrencyContext";
import { FaHeart, FaPen } from "react-icons/fa";
import ExternalLinkButton from "../../ExternalLinkButton";

const FlightCard = ({ flights, manual, handleDelete, handleEdit }) => {
  // console.log("flights", flights);
  const { convertCurrency, currency } = useCurrency();

  const convertedPrice = convertCurrency(flights.price, "USD");

  // Function to handle box click and open link
  const handleBoxClick = () => {
    window.open(flights.link, "_blank", "noopener,noreferrer");
  };

  return (
    <Box
      borderWidth="1px"
      borderRadius="lg"
      overflow="hidden"
      cursor="pointer"
      onClick={handleBoxClick}
      p={2}
    >
      <VStack
        p={2}
        borderRadius="xl"
        alignItems="flex-start"
        w="100%"
        spacing={3}
        bg="white"
        h="100%"
      >
        {/* Price and Airline Info */}
        <Box width="100%" position="relative">
          <Text fontWeight="bold" fontSize="md" mt={2} mb={2}>
            <Translate text="Price:" /> {currency} {convertedPrice}
          </Text>
          <IconButton
            aria-label="Add to favorites"
            icon={<FaHeart />}
            size="md"
            bg="none"
            _hover={{ bg: "none" }}
            position="absolute"
            top="0px"
            right="0px"
            borderRadius="full"
            color="red.500"
            onClick={handleDelete}
          />
          <Text fontSize="sm" color="gray.500" mb={0}>
            <Translate text="Airline: " /> {flights.airline}
          </Text>
        </Box>

        {/* Flight Information */}
        <HStack
          justify="space-between"
          width="full"
          spacing={0}
          bg="blackAlpha.50"
          padding={2}
          borderRadius="xl"
        >
          <VStack align="center" spacing={0}>
            <Text fontWeight="bold">{flights.origin}</Text>
            <Text fontSize="xs" color="gray.500">
              {new Date(flights.departure_at).toLocaleDateString()}
            </Text>
          </VStack>
          <VStack align="center" spacing={0} mt={3}>
            <Text fontSize="xs">
              {Math.floor(flights.duration_to / 60)}h {flights.duration_to % 60}
              m
            </Text>
            {flights.return_transfers === 1 ? (
              <VStack spacing={0.5}>
                <Text fontSize="xs" mb={0}>
                  ➔
                </Text>
                <Text
                  fontSize="xs"
                  mb={0}
                  style={{ transform: "scaleX(-1)", display: "inline-block", marginTop: "-6px"  }}
                >
                  ➔
                </Text>
              </VStack>
            ) : (
              <Text fontSize="xs" mb={0}>
                ➔
              </Text>
            )}
            <Text fontSize="xs" color="gray.500">
              {flights.transfers > 0 ? `${flights.transfers} stop` : "Non-stop"}
            </Text>
          </VStack>
          <VStack align="center" spacing={0}>
            <Text fontWeight="bold">{flights.destination}</Text>
            <Text fontSize="xs" color="gray.500">
              {new Date(flights.return_at).toLocaleDateString()}
            </Text>
          </VStack>
        </HStack>
        <Text display="flex" fontWeight="bold" fontSize="md" mt={2} mb={2}>
          {" "}
          <Translate text="Flight No:" /> {flights.flight_number}
          {manual === "manual" && (
            <IconButton
              aria-label="Edit flight"
              icon={<FaPen />}
              size="sm"
              bg="none"
              _hover={{ bg: "gray.100" }}
              ml={2}
              onClick={(e) => {
                e.stopPropagation();
                handleEdit(flights);
              }}
            />
          )}
        </Text>
        {/* <Spacer /> */}
        {/* Book Button */}
        <ExternalLinkButton
          as="a"
          href={flights.link}
          rel="noopener noreferrer"
          size="sm"
          bg="#286328"
          _hover="none"
          _active="none"
          textColor="white"
          width="full"
        >
          <Translate text="Book" />
        </ExternalLinkButton>
      </VStack>
    </Box>
  );
};

export default FlightCard;
